import { Box } from "@mui/material";

import Map from "components/map/Map";
import Legends from "components/map/Legends";
import MapControlsAccordion from "components/map/MapControlsAccordion";
import ProjectBreadcrumb from "components/project/ProjectBreadcrumb";
import usePage from "hooks/usePage";
import UrbanSimulationDetails from "components/map/UrbanSimulationDetails";
import RiskMap from "components/map/RiskMap";
import ViewerProjectBreadcrumb from "components/project/ViewerProjectBreadcrumb";
import { useAuth } from "contexts/AuthContext";
import { useMapState } from "contexts/MapStateContext";
import useFetch from "hooks/useFetch";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import _isNaN from "lodash/isNaN";

const AppBody = () => {
  const {
    isUrbanPage,
    isVegetationPage,
    isRiskPage,
    runId,
    isSharePage,
    projectId,
  } = usePage();
  const { currentUser } = useAuth();
  const { setBasemap } = useMapState();
  const navigate = useNavigate();
  const { data: project } = useFetch(
    `/hash/project/${projectId}`,
    {},
    !!projectId && !!currentUser && _isNaN(Number(projectId))
  );

  useEffect(() => {
    if (isSharePage && currentUser && project) {
      navigate(`/project/${project?.id}`);
    }
  }, [currentUser, isSharePage, project, navigate]);

  const { data: simulation } = useFetch(
    `/hash/simulation/${runId}`,
    {},
    !!runId && !!currentUser && _isNaN(Number(runId))
  );

  useEffect(() => {
    if (isSharePage && currentUser && simulation) {
      navigate(`/simulation/${simulation?.id}`);
    }
  }, [currentUser, isSharePage, simulation, navigate]);

  useEffect(() => {
    if (isRiskPage) {
      setBasemap("default");
    }
  }, [isRiskPage, setBasemap]);

  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        height: "100%",
      }}
    >
      {isSharePage ? <ViewerProjectBreadcrumb /> : <ProjectBreadcrumb />}
      <Map
        shareable={isUrbanPage}
        variant={isVegetationPage ? "intermix" : "basic"}
      />
      <Legends />

      {isVegetationPage && runId && <MapControlsAccordion type="vegetation" />}
      {isUrbanPage && runId && (
        <>
          <UrbanSimulationDetails />
          <MapControlsAccordion type="urban" />
        </>
      )}
      {isRiskPage && <RiskMap />}
    </Box>
  );
};

export default AppBody;
